<template>
  <el-dialog
    append-to-body
    width="600px"
    :visible.sync="visible"
    :before-close="reset"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <template #title>
      <div class="el-dialog-title">修改密码</div>
    </template>
    <el-form
      ref="elFormDomUploadDialog"
      label-width="80px"
      :model="form.data"
      :rules="form.rules"
    >
      <el-row type="flex" style="justify-content: center">
        <el-col :span="24">
          <el-form-item label="新密码:" prop="password">
            <el-input
              v-model.trim="form.data.password"
              prefix-icon="el-icon-lock"
              clearable
              show-password
              placeholder="请输入"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <template #footer>
      <el-row type="flex" justify="center">
        <el-button
          v-loading="btnLoading"
          :disabled="btnLoading"
          type="primary"
          @click="conFirm"
          >保存</el-button
        >
      </el-row>
    </template>
  </el-dialog>
</template>
<script>
export default {
  data() {
    return {
      info: {},
      btnLoading: false,
      visible: false,
      form: {
        data: {
          password: "",
        },
        rules: {
          password: [{ required: true, message: "必填项", trigger: "change" }],
        },
      },
    };
  },
  methods: {
    toggle(val) {
      this.visible = val;
    },
    getDetail(row) {
      this.info = row;
    },
    reset() {
      this.visible = false;
      this.$refs.elFormDomUploadDialog.resetFields();
    },
    conFirm() {
      this.$refs.elFormDomUploadDialog.validate((valid) => {
        if (valid) {
          let params = {
            password: this.form.data.password,
            id:this.info.id,
          };
          this.btnLoading = true;
          this.$http
            .post("/admin/admin/setPwd", params)
            .then((res) => {
              if (res.code == 1) {
                this.$message.success("修改成功");
                this.reset();
                this.$emit("update");
              }
            }).finally(() =>{
              this.btnLoading = false;
            })
        }
      });
    },
  },
};
</script>